import script from "./Co2Question.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2Question.vue?vue&type=script&lang=ts&setup=true"

import "./Co2Question.vue?vue&type=style&index=0&id=00e209ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e209ac"]])

export default __exports__